import { Pie } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import ChartJSDataLabel from 'chartjs-plugin-datalabels'
import { Chart as CJS } from "chart.js";

export const PieChart = ({data, config}) => {
  CJS.register(ChartJSDataLabel)
  return (
    <Pie data={data} {...config} />
  )
}